import {ReportData} from "../../../reports/report.data";
import {collection} from "@fedeltapointofsale/data-client";


export class ProductsSoldReportData extends ReportData<ProductsSoldReportData> {
    @collection() groupBy: string[] = ["none"];
}
